import {Row} from "antd";
import RenderList from "./fragments/RenderList";
import SubHeader from "./fragments/SubHeader";
import {LinearProgress} from "@material-ui/core";

import useCategories from "../../hooks/useCategories";

import 'bootstrap/dist/css/bootstrap.min.css';

export default function CategoriesView() {

    const {categories, loading} = useCategories();

    return (
        <>
            <SubHeader />

            <RenderList data={categories}/>

            {
                loading && (
                    <Row style={{display: 'grid', placeItems: 'center'}}>
                        <LinearProgress/>
                    </Row>
                )
            }
        </>
    )
}
